import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { assetsSchemasRoute } from '@atlassian/jira-router-routes-assets-routes/src/assetsSchemasRoute.tsx';
import { getAssetsAppResources } from '@atlassian/jira-router-routes-servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { landingPageEntryPoint } from '@atlassian/jira-spa-apps-servicedesk-cmdb-landing-page/src/entrypoint.tsx';
import { LazyAssetsLayout, AssetsLayout } from '@atlassian/jira-assets-layout/src/ui/async.tsx';
import { AssetsPageConfigContainer } from '@atlassian/jira-assets-app-page-config-container/src/ui/async.tsx';
import Spinner from '@atlassian/jira-common-components-spinner/src/view.tsx';

const assetsPageEntryPoint = createChromelessEntryPoint({
	main: landingPageEntryPoint,
});

export const assetsSchemasRouteEntry = createEntry(assetsSchemasRoute, () => ({
	group: 'assets',
	LayoutOverrideComponent: AssetsLayout,
	PageConfigContainerOverride: AssetsPageConfigContainer,
	skeleton: Spinner,
	entryPoint: () => assetsPageEntryPoint,
	pageId: () => 'spa-apps/servicedesk/insight/cmdb-landing-page',
	resources: getAssetsAppResources(),
	forPaint: [LazyAssetsLayout],
	perfMetricKey: 'assets-app-schemas-page',
	ufoName: 'assets-app-schemas-page',
	bifrost: {
		bifrostGroup: 'shell-only',

		bundling: {
			packageName: '@atlassian/jira-router-routes-assets-entries/src/assetsSchemasRouteEntry.tsx',
			whichExportToUse: 'assetsSchemasRouteEntry',
		},

		enabled: true,
	},
}));
